import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RightsScopeEnum } from '../../../../enums/rights/rights-scope.enum';
import { RUserArea } from './r-user-area.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RUserAreaXsStateModel {
  //organization
  viewOrganizationUserArea: string;
  createOrganizationUserArea: string;
  editOrganizationUserArea: string;
  deleteOrganizationUserArea: string;
  //community
  viewCommunityUserArea: string;
  createCommunityUserArea: string;
  editCommunityUserArea: string;
  deleteCommunityUserArea: string;
}

const getDefaults = () : RUserAreaXsStateModel => ({

  viewOrganizationUserArea: null,
  createOrganizationUserArea: null,
  editOrganizationUserArea: null,
  deleteOrganizationUserArea: null,

  viewCommunityUserArea: null,
  createCommunityUserArea: null,
  editCommunityUserArea: null,
  deleteCommunityUserArea: null
});

@State<RUserAreaXsStateModel>({
  name: 'rUserArea',
  defaults: getDefaults()
})
@Injectable()
export class RUserAreaXsState {

  //region SELECTOR
  @Selector()
  static canCreateAnyUserArea(state: RUserAreaXsStateModel) : boolean {
    return state.createCommunityUserArea != null || state.createOrganizationUserArea != null;
  }

  @Selector()
  static canViewAnyUserArea(state: RUserAreaXsStateModel) : boolean {
    return state.viewCommunityUserArea != null || state.viewOrganizationUserArea != null;
  }

  static canViewUserArea(scope: RightsScopeEnum) {
    return createSelector([RUserAreaXsState], (state: RUserAreaXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.GLOBAL:
          return false;
        case RightsScopeEnum.ORGANIZATION:
          return state.viewOrganizationUserArea != null;
        case RightsScopeEnum.COMMUNITY:
          return state.viewCommunityUserArea != null;
      }
      return false;
    });
  }

  static canCreateUserArea(scope: RightsScopeEnum) {
    return createSelector([RUserAreaXsState], (state: RUserAreaXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.GLOBAL:
          return false;
        case RightsScopeEnum.ORGANIZATION:
          return state.createOrganizationUserArea != null;
        case RightsScopeEnum.COMMUNITY:
          return state.createCommunityUserArea != null;
      }
      return false;
    });
  }

  static canEditUserArea(scope: RightsScopeEnum) {
    return createSelector([RUserAreaXsState], (state: RUserAreaXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.GLOBAL:
          return false;
        case RightsScopeEnum.ORGANIZATION:
          return state.editOrganizationUserArea != null;
        case RightsScopeEnum.COMMUNITY:
          return state.editCommunityUserArea != null;
      }
      return false;
    });
  }

  static canDeleteUserArea(scope: RightsScopeEnum) {
    return createSelector([RUserAreaXsState], (state: RUserAreaXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.GLOBAL:
          return false;
        case RightsScopeEnum.ORGANIZATION:
          return state.deleteOrganizationUserArea != null;
        case RightsScopeEnum.COMMUNITY:
          return state.deleteCommunityUserArea != null;
      }
      return false;
    });
  }
  //endregion

  //region ACTIONS
  @Action(RUserArea.SetUserAreaPrivileges)
  public setUserAreaPrivileges(ctx: StateContext<RUserAreaXsStateModel>, action: RUserArea.SetUserAreaPrivileges) {
    const state = ctx.getState();
    const userRightsSystemPrivileges = [...action.activeUserRightsRoleDtoModel.userRightsSystemPrivileges];

    //find user privilege data model

    const viewOrganizationUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ORGANIZATION_USER_AREA);
    const createOrganizationUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.CREATE_ORGANIZATION_USER_AREA);
    const editOrganizationUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.EDIT_ORGANIZATION_USER_AREA);
    const deleteOrganizationUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.DELETE_ORGANIZATION_USER_AREA);

    const viewCommunityUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.VIEW_COMMUNITY_USER_AREA);
    const createCommunityUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.CREATE_COMMUNITY_USER_AREA);
    const editCommunityUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.EDIT_COMMUNITY_USER_AREA);
    const deleteCommunityUserArea = userRightsSystemPrivileges.find(id => id === UserPrivilegeEnum.DELETE_COMMUNITY_USER_AREA);


      //set the state
    ctx.setState({
      ...state,

      viewOrganizationUserArea: viewOrganizationUserArea,
      createOrganizationUserArea: createOrganizationUserArea,
      editOrganizationUserArea: editOrganizationUserArea,
      deleteOrganizationUserArea: deleteOrganizationUserArea,

      viewCommunityUserArea: viewCommunityUserArea,
      createCommunityUserArea: createCommunityUserArea,
      editCommunityUserArea: editCommunityUserArea,
      deleteCommunityUserArea:  deleteCommunityUserArea
    });

  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RUserAreaXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
